import React from "react";

export default function Files() {
  return <div>Files</div>;
}
